import { createContext, useContext, useState } from "react";

const translations = {
  it: {
    nav: {
      stays: "Soggiorna",
      villas: "OGStay Villas",
      experiences: "Esperienze",
      owners: "Proprietari",
      metodo: "Metodo",
      about: "Chi siamo",
      structures: "Le nostre strutture",
      portal: "Portale Proprietari",
      menu: "Menu",
      close: "Chiudi il menu",
    },
    whatsapp: {
      title: "Come possiamo aiutarti?",
      guest: "Cerchi un soggiorno?",
      owner: "Sei un proprietario?",
      guestMsg: "Ciao OGStay, avrei bisogno di informazioni per un soggiorno in Ogliastra.",
      ownerMsg: "Ciao OGStay, vorrei ricevere informazioni sulla gestione del mio immobile.",
      close: "Chiudi",
    },
    hero: {
      kicker: "Ospitalità boutique · Ogliastra, Sardegna",
      lines: ["L'Ogliastra, con", "un'ospitalità diversa."],
      sub: "La libertà di una casa. La cura dell'alta hôtellerie. Soggiorni selezionati, un team locale e servizi pensati per vivere l'Ogliastra in ogni dettaglio.",
      ctaPrimary: "Esplora le nostre case",
      ctaSecondary: "Scopri il nostro metodo",
      search: {
        where: "Dove",
        wherePh: "Tortolì, Arbatax…",
        checkin: "Check-in",
        checkout: "Check-out",
        guests: "Ospiti",
        guestsPh: "2 ospiti",
        button: "Cerca",
      },
      scroll: "Scorri",
    },
    stays: {
      tag: "Le Case",
      title: "Le case OGStay, in diretta",
      sub: "Disponibilità in tempo reale e prenotazione diretta: nessuna commissione, nessun intermediario.",
      badges: ["Prenotazione diretta", "Zero commissioni", "Disponibilità in tempo reale"],
      external: "Apri il portale di prenotazione in una nuova scheda",
      loading: "Caricamento del portale di prenotazione…",
    },
    marquee: ["Tortolì", "Arbatax", "Baunei", "Santa Maria Navarrese", "Cardedu", "Bari Sardo", "Live Ogliastra", "Stay Local"],
    chapters: {
      ch1: {
        num: "01",
        tag: "Per chi viaggia",
        title: "Vivi l'Ogliastra autentica",
        sub: "Dove ogni soggiorno diventa un ricordo indimenticabile.",
        features: [
          "Case selezionate e verificate",
          "Prenotazioni dirette, zero commissioni",
          "Team locale sempre disponibile",
          "Esperienze autentiche su misura",
        ],
        note: "Non solo soggiorni. Ci prendiamo cura della tua esperienza.",
        cta: "Scopri le case",
      },
      ch2: {
        num: "02",
        tag: "Per i proprietari",
        title: "Più valore, meno pensieri",
        sub: "La tua proprietà merita una gestione che genera risultati.",
        features: [
          "Gestione completa o modulare",
          "Portali + prenotazioni dirette",
          "Ottimizzazione ricavi continua",
          "Team locale, controllo reale",
        ],
        note: "Gestiamo la complessità, tu vivi la tranquillità.",
        cta: "Valuta il tuo immobile",
      },
    },
    properties: {
      tag: "Case selezionate",
      title: "Rifugi scelti in Ogliastra",
      sub: "Dove il mare cristallino incontra le montagne selvagge. Ogni casa è un rifugio autentico che ti fa sentire a casa, lontano da casa.",
      guests: "ospiti",
      rooms: "camere",
      from: "Da",
      night: "/ notte",
      cta: "Vedi tutte le case",
      ctaCardTitle: "Tutte le case",
      ctaCardSub: "Esplora la collezione completa",
      checkAvailability: "Verifica disponibilità",
      items: [
        { location: "Tortolì", guests: 6, rooms: 3, price: null },
        { location: "Tortolì", guests: 8, rooms: 3, price: null },
      ],
    },
    why: {
      tag: "Perché OGStay",
      title: "Il tuo partner locale, ogni giorno",
      sub: "Viviamo e respiriamo l'Ogliastra. Passione, territorio e risultati concreti.",
      items: [
        { title: "Team locale", text: "Presenza fisica e conoscenza profonda del territorio." },
        { title: "Qualità garantita", text: "Standard elevati per ospiti e proprietari, sempre." },
        { title: "Risultati concreti", text: "Esperienze autentiche e ricavi ottimizzati." },
      ],
      stats: [
        { value: "100%", label: "Team del territorio" },
        { value: "0", label: "Commissioni sul diretto" },
        { value: "24h", label: "Assistenza locale" },
      ],
    },
    experiences: {
      tag: "Esperienze",
      title: "Esperienze autentiche",
      sub: "Immergiti nell'anima della Sardegna più vera. Ogni esperienza è un viaggio che tocca il cuore e resta per sempre.",
      from: "Da",
      person: "/ persona",
      cta: "Vedi tutte le esperienze",
      items: [
        { title: "Escursione in barca nel Golfo di Orosei", text: "Acque cristalline e spiagge incontaminate, con un tour guidato in barca.", price: "€95" },
        { title: "Degustazione vini in cantina", text: "Un viaggio sensoriale tra i sapori autentici con degustazione guidata di vini locali.", price: "€45" },
        { title: "Trekking nel Gennargentu", text: "Natura selvaggia e panorami mozzafiato con una guida esperta del territorio.", price: "€60" },
      ],
    },
    testimonials: {
      tag: "Testimonianze",
      verifiedTitle: "5 su 5 su Airbnb",
      verifiedSub: "Recensioni verificate degli ospiti",
      title: "Cosa dicono di noi",
      sub: "Storie vere, emozioni autentiche, fiducia conquistata.",
      items: [
        { quote: "Gestione professionale e guadagni aumentati del 40%. Finalmente senza stress.", name: "Paolo R.", role: "Proprietario" },
        { quote: "Team locale sempre disponibile. La mia casa è in ottime mani.", name: "Maria S.", role: "Proprietaria" },
        { quote: "Esperienza meravigliosa! Struttura perfetta e assistenza impeccabile.", name: "Francesca M.", role: "Ospite" },
      ],
    },
    finalCta: {
      title: "Inizia il tuo viaggio in Ogliastra",
      sub: "Il tuo sogno sardo inizia qui. Prenota senza commissioni o scopri come trasformiamo la tua proprietà in successo.",
      ctaPrimary: "Esplora le case",
      ctaSecondary: "Richiedi valutazione",
    },
    footer: {
      tagline: "Live Ogliastra. Stay Local.",
      explore: "Esplora",
      owners: "Proprietari",
      about: "OGStay",
      contact: "Contatti",
      links: { stays: "Soggiorna", experiences: "Esperienze", guide: "Guide" },
      ownerLinks: { services: "Gestione proprietà", valuation: "Valutazione gratuita", portal: "Portale proprietari" },
      aboutLinks: { chiSiamo: "Chi siamo" },
      legalLinks: { privacy: "Privacy Policy", cookie: "Cookie Policy", terms: "Termini e condizioni" },
      whatsapp: "WhatsApp",
      googleBusiness: "Trovaci su Google",
      location: "Ogliastra · Sardegna, Italia",
      rights: "Tutti i diritti riservati.",
    },
    valuation: {
      title: "Valuta il tuo immobile",
      sub: "Richiedi una valutazione gratuita: ti ricontattiamo entro 24 ore con un'analisi del potenziale della tua proprietà.",
      name: "Nome e cognome",
      namePh: "Maria Piras",
      email: "Email",
      emailPh: "maria@email.it",
      phone: "Telefono (facoltativo)",
      phonePh: "+39 333 000 0000",
      location: "Località dell'immobile",
      locationPh: "Tortolì, Arbatax, Baunei…",
      type: "Tipologia",
      types: ["Appartamento", "Villa", "Casa indipendente", "B&B / Affittacamere", "Altro"],
      message: "Messaggio (facoltativo)",
      messagePh: "Raccontaci la tua proprietà…",
      submit: "Richiedi valutazione",
      sending: "Invio in corso…",
      success: "Richiesta inviata. Ti ricontatteremo entro 24 ore.",
      error: "Qualcosa non ha funzionato. Riprova tra poco.",
    },
  },
  en: {
    nav: {
      stays: "Stays",
      villas: "OGStay Villas",
      experiences: "Experiences",
      owners: "Owners",
      metodo: "Our method",
      about: "About us",
      structures: "Our properties",
      portal: "Owner Portal",
      menu: "Menu",
      close: "Close menu",
    },
    whatsapp: {
      title: "How can we help?",
      guest: "Looking for a stay?",
      owner: "Are you an owner?",
      guestMsg: "Hi OGStay, I'd like some information for a stay in Ogliastra.",
      ownerMsg: "Hi OGStay, I'd like information about managing my property.",
      close: "Close",
    },
    hero: {
      kicker: "Boutique hospitality · Ogliastra, Sardinia",
      lines: ["The Ogliastra, with", "a different hospitality."],
      sub: "The freedom of a home. The care of high-end hôtellerie. Selected stays, a local team and services designed to experience Ogliastra in every detail.",
      ctaPrimary: "Explore our homes",
      ctaSecondary: "Discover our method",
      search: {
        where: "Where",
        wherePh: "Tortolì, Arbatax…",
        checkin: "Check-in",
        checkout: "Check-out",
        guests: "Guests",
        guestsPh: "2 guests",
        button: "Search",
      },
      scroll: "Scroll",
    },
    stays: {
      tag: "Stays",
      title: "OGStay homes, live",
      sub: "Real-time availability and direct booking: no commissions, no middlemen.",
      badges: ["Direct booking", "Zero commissions", "Real-time availability"],
      external: "Open the booking portal in a new tab",
      loading: "Loading the booking portal…",
    },
    marquee: ["Tortolì", "Arbatax", "Baunei", "Santa Maria Navarrese", "Cardedu", "Bari Sardo", "Live Ogliastra", "Stay Local"],
    chapters: {
      ch1: {
        num: "01",
        tag: "For travellers",
        title: "Live authentic Ogliastra",
        sub: "Where every stay becomes an unforgettable memory.",
        features: [
          "Handpicked, verified homes",
          "Direct bookings, zero commissions",
          "Local team always available",
          "Tailor-made authentic experiences",
        ],
        note: "More than stays. We take care of your whole experience.",
        cta: "Explore the homes",
      },
      ch2: {
        num: "02",
        tag: "For owners",
        title: "More value, less worry",
        sub: "Your property deserves management that delivers results.",
        features: [
          "Full or modular management",
          "Portals + direct bookings",
          "Continuous revenue optimisation",
          "Local team, real control",
        ],
        note: "We handle the complexity, you enjoy the peace of mind.",
        cta: "Value your property",
      },
    },
    properties: {
      tag: "Selected homes",
      title: "Chosen retreats in Ogliastra",
      sub: "Where crystal-clear sea meets wild mountains. Every home is an authentic retreat that makes you feel at home, away from home.",
      guests: "guests",
      rooms: "bedrooms",
      from: "From",
      night: "/ night",
      cta: "See all homes",
      ctaCardTitle: "All homes",
      ctaCardSub: "Browse the full collection",
      checkAvailability: "Check availability",
      items: [
        { location: "Tortolì", guests: 6, rooms: 3, price: null },
        { location: "Tortolì", guests: 8, rooms: 3, price: null },
      ],
    },
    why: {
      tag: "Why OGStay",
      title: "Your local partner, every day",
      sub: "We live and breathe Ogliastra. Passion, territory and concrete results.",
      items: [
        { title: "Local team", text: "Physical presence and deep knowledge of the territory." },
        { title: "Guaranteed quality", text: "High standards for guests and owners, always." },
        { title: "Concrete results", text: "Authentic experiences and optimised revenue." },
      ],
      stats: [
        { value: "100%", label: "Local territory team" },
        { value: "0", label: "Commissions on direct" },
        { value: "24h", label: "Local assistance" },
      ],
    },
    experiences: {
      tag: "Experiences",
      title: "Authentic experiences",
      sub: "Immerse yourself in the soul of the truest Sardinia. Every experience is a journey that touches the heart and lasts forever.",
      from: "From",
      person: "/ person",
      cta: "See all experiences",
      items: [
        { title: "Boat trip in the Gulf of Orosei", text: "Crystal-clear waters and untouched beaches on a guided boat tour.", price: "€95" },
        { title: "Winery wine tasting", text: "A sensory journey through authentic flavours with a guided local wine tasting.", price: "€45" },
        { title: "Trekking in the Gennargentu", text: "Wild nature and breathtaking views with an expert local guide.", price: "€60" },
      ],
    },
    testimonials: {
      tag: "Testimonials",
      verifiedTitle: "5 out of 5 on Airbnb",
      verifiedSub: "Verified guest reviews",
      title: "What they say about us",
      sub: "True stories, authentic emotions, earned trust.",
      items: [
        { quote: "Professional management and earnings up by 40%. Finally stress-free.", name: "Paolo R.", role: "Owner" },
        { quote: "Local team always available. My home is in great hands.", name: "Maria S.", role: "Owner" },
        { quote: "Wonderful experience! Perfect property and impeccable assistance.", name: "Francesca M.", role: "Guest" },
      ],
    },
    finalCta: {
      title: "Begin your journey in Ogliastra",
      sub: "Your Sardinian dream starts here. Book commission-free or discover how we turn your property into a success.",
      ctaPrimary: "Explore the homes",
      ctaSecondary: "Request a valuation",
    },
    footer: {
      tagline: "Live Ogliastra. Stay Local.",
      explore: "Explore",
      owners: "Owners",
      about: "OGStay",
      contact: "Contact",
      links: { stays: "Stays", experiences: "Experiences", guide: "Journal" },
      ownerLinks: { services: "Property management", valuation: "Free valuation", portal: "Owner portal" },
      aboutLinks: { chiSiamo: "About us" },
      legalLinks: { privacy: "Privacy Policy", cookie: "Cookie Policy", terms: "Terms & Conditions" },
      whatsapp: "WhatsApp",
      googleBusiness: "Find us on Google",
      location: "Ogliastra · Sardinia, Italy",
      rights: "All rights reserved.",
    },
    valuation: {
      title: "Value your property",
      sub: "Request a free valuation: we'll get back to you within 24 hours with an analysis of your property's potential.",
      name: "Full name",
      namePh: "Maria Piras",
      email: "Email",
      emailPh: "maria@email.com",
      phone: "Phone (optional)",
      phonePh: "+39 333 000 0000",
      location: "Property location",
      locationPh: "Tortolì, Arbatax, Baunei…",
      type: "Property type",
      types: ["Apartment", "Villa", "Detached house", "B&B / Guesthouse", "Other"],
      message: "Message (optional)",
      messagePh: "Tell us about your property…",
      submit: "Request valuation",
      sending: "Sending…",
      success: "Request sent. We'll be in touch within 24 hours.",
      error: "Something went wrong. Please try again shortly.",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("it");
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}

export function scrollToSection(hash) {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
